import store from "@/store";
import request from "@/utils/request";

export async function getUserList(params) {
    console.log("@@ get list : getUserList");
    let result = request.get("/api/user/",{params});
    return result;
}
export async function getUserDetail(params) {
    console.log("@@ get detail : getUserDetail");
    let result = request.get("/api/user/item",{params});
    return result;
}

export async function setSuspended(params) {
    console.log("@@ get list : setSuspended");
    let result = request.post("/api/user/userLoginBlocked/",params);
    return result;
}

export async function DeleteSuspended(params) {
    console.log("@@ delete : DeleteSuspended");
    let result = request.delete("/api/user/userLoginBlocked/",{params});
    return result;
}

// 탈퇴회원 목록
export async function getUserWithdrawn(params) {
    console.log("@@ get list : getUserWithdrawn");
    let result = request.get("/api/user/userWithdrawn/",{params});
    return result;
}

// 서류인증 : 목록
export async function getUserTeacherList(params) {
    console.log("@@ get list : getUserTeacherList");
    let result = request.get("/api/user/userTeacher/", {params});
    return result;
}

// 서류인증 : 상세
export async function getUserTeacherDetail(loginId) {
    console.log("@@ get detail : getUserTeacherDetail");
    let result = request.get(`/api/user/userTeacher/detail/${loginId}`);
    return result;
}

// 서류인증 : 인증하기
export async function setUserTeacherCertify(params) {
    console.log("@@ post : setUserTeacherCertify");
    let result = request.post("/api/user/userTeacher/certify", params);
    return result;
}

// 서류인증 : 거절하기
export async function setUserTeacherReject(params) {
    console.log("@@ post : setUserTeacherReject");
    let result = request.post("/api/user/userTeacher/reject", params);
    return result;
}

// 서류인증 : 삭제하기
export async function deleteUserTeacherFile(params) {
    console.log("@@ delete : deleteUserTeacherFile");
    let result = request.post("/api/user/userTeacher/deleteFile", params);
    return result;
}

// 정회원취소
export async function setUserTeacherCancelRegular(params) {
    console.log("@@ post : setUserTeacherCancelRegular");
    let result = request.post("/api/user/userTeacher/cancelRegular", params);
    return result;
}